// extracted by mini-css-extract-plugin
module.exports = {"button":"ResetButton_button__h3bU9","buttonLink":"ResetButton_buttonLink__14csu"};